<div class="menu-group-head">
  <div class="menu-group-tit">
    <i class="ic ic-menu1"></i>
    <span class="txt">지역별 이야기</span>
  </div>
</div>

<div class="menu-group-body">
  <div class="label-select-list">
    <div *ngFor="let cityInfo of allCityInfoList"
         class="label-select-box {{ cityInfo.city2 === '전국' ? 'double' : '' }}">

      <div class="label type-{{ cityInfo.css }}"
           [class.on]="selectedCity === cityInfo.city2"
           [class.inactive]="!isCityAvailable(cityInfo)"
           (click)="onChangeCity($event, cityInfo.city2)">
        <div class="txt-box"
             [innerHTML]="cityInfo.listTxt | citySize | resize | keepHtml">
        </div>
      </div>
    </div>
  </div>
</div>
